import { combineBytes } from "../utils";
import { CAN_FUNC_TX1, CAN_FUNC_TX2, CAN_FUNC_TX3, CAN_FUNC_TX4, HOT_WATER_NODE_ID } from "../constants";

export function handleHotWaterPacket(id, payload, hotWater, bleEventDispatcher) {
	// ID: CAN_FUNC_TX1 + HOT_WATER_NODE_ID
	if (id === CAN_FUNC_TX1 + HOT_WATER_NODE_ID) {
		hotWater.underfloor_pump = payload[0];
		hotWater.radiator_pump = payload[1];
		hotWater.big_pump = payload[2];
		hotWater.fill_valve = payload[3];
		hotWater.flush_valve = payload[4];
		hotWater.led1_state = payload[5];
		hotWater.immersion_heater_state = payload[6];
		hotWater.water_level = payload[7];
		bleEventDispatcher.emit("hotWater", hotWater);
		return true;
	}

	// ID: CAN_FUNC_TX2 + HOT_WATER_NODE_ID
	if (id === CAN_FUNC_TX2 + HOT_WATER_NODE_ID) {
		hotWater.autoheat = payload[0];
		hotWater.heatfloor = payload[1];
		hotWater.temp = combineBytes(payload[2], payload[3]) / 100;
		hotWater.target_temp = payload[4];
		hotWater.autofill_level = payload[5];
		bleEventDispatcher.emit("hotWater", hotWater);
		return true;
	}

	// ID: CAN_FUNC_TX3 + HOT_WATER_NODE_ID
	if (id === CAN_FUNC_TX3 + HOT_WATER_NODE_ID) {
		hotWater.uptime = (payload[0] << 24) | (payload[1] << 16) | (payload[2] << 8) | payload[3];
		hotWater.immersion_timer_remaining = (payload[4] << 8) | payload[5]; // minutes
		hotWater.battery_data_fresh = payload[6];
		bleEventDispatcher.emit("hotWater", hotWater);
		return true;
	}

	// ID: CAN_FUNC_TX4 + HOT_WATER_NODE_ID - Battery Heating Status
	if (id === CAN_FUNC_TX4 + HOT_WATER_NODE_ID) {
		hotWater.soc_threshold = payload[0];
		hotWater.soc_timer_remaining = (payload[1] << 8) | payload[2]; // hours
		hotWater.watt_soc_threshold = payload[3];
		hotWater.watt_timer_remaining = (payload[4] << 8) | payload[5]; // hours
		bleEventDispatcher.emit("hotWater", hotWater);
		return true;
	}

	return false;
}
